import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import { saveUTMSessionParams } from "pubweb-smokey/dist/utils/utils";

import styled, { ThemeProvider, injectGlobal } from 'styled-components';

import '../styles/index.scss';

import LandingCard from '../components/LandingCard/LandingCard';
import LandingHeader from '../components/LandingHeader/LandingHeader';
import LandingFooter from '../components/LandingFooter/LandingFooter';
import ScriptTags from '../components/ScriptTags';
import { 
  onHelmetChangeClientState, 
  send 
} from '../utils/Analytics';

import LandingPageStyles from '../styles/LandingPageStyles';

import ImageSet from '../utils/ImageSets';

import mobileImage1 from '../images/mobile/mobile-quality-bg.jpg';
import mobileImage2 from '../images/mobile/mobile-affordability-bg.jpg';
import mobileImage3 from '../images/mobile/mobile-style-bg.jpg';

import tabletImage1 from '../images/tablet/tablet-quality-bg.jpg';
import tabletImage2 from '../images/tablet/tablet-affordability-bg.jpg';
import tabletImage3 from '../images/tablet/tablet-style-bg.jpg';

import desktopImage1 from '../images/desktop/quality-bg.jpg';
import desktopImage2 from '../images/desktop/affordability-bg.jpg';
import desktopImage3 from '../images/desktop/style-bg.jpg';

import colors from 'pubweb-react-components/dist/styles/colors';

injectGlobal`
  html {
      /* - DESKTOP VIEW - */
      @media screen and (${LandingPageStyles.viewBreakpoints.desktop}){
        min-height: 600px;
      }
      
      /* - TABLET VIEW - */
      @media screen and (max-width: 1024px){
        min-height: 768px;
      }

      /* - MOBILE VIEW - */
      @media screen and (max-width: 425px){
        min-height: 640px;
      }
  }
`;

require('es6-object-assign').polyfill();

const LandingPageContainer = styled.div`
  height: 100%;

  .cards-container {
    height: 100%;
  }
  .copyright-sup {
    font-size: 10px;
    vertical-align: super;
  }

  &.main-content {
    display: block;
  }
  
`;



const cardBackgroundImages = [
  new ImageSet(mobileImage1, tabletImage1, desktopImage1),
  new ImageSet(mobileImage2, tabletImage2, desktopImage2),
  new ImageSet(mobileImage3, tabletImage3, desktopImage3)
];


const IndexPage = (props) => {

  // save any utm params to local session cache
  if(props.location && props.location.search) {
    saveUTMSessionParams(props.location.search);
  }
  
	return (
		  <LandingPageContainer className="main-content">
			<LandingHeader />
			<div className="cards-container">

			  <LandingCard
				backgroundImages={cardBackgroundImages[0]}
				linkUrl="/quality"
				headerText="Quality"
				animationColor={colors.primaryClaytonBlue}
        onClick={() => {send('HIM2018', 'Button', 'Main LP - Quality');}}>
				<span className="view-mobile view-tablet">Our homes are built to stand up to a lifetime of memories.</span>
				<span className="view-desktop">
				  <span className="card-line">Learn why Clayton Built<span className="copyright-sup">&copy;</span> means</span>
				  <span className="card-line">quality you can trust.</span>
				</span>
			  </LandingCard>

			  <LandingCard
				backgroundImages={cardBackgroundImages[1]}
				linkUrl="/affordability"
				headerText="Affordability"
				animationColor={colors.primaryClaytonGreen}
        onClick={() => {send('HIM2018', 'Button', 'Main LP - Affordability');}}>
				<span className="view-mobile view-tablet">Get the home you want at a price you can afford.</span>
				<span className="view-desktop">
				  <span className="card-line">See how we keep costs down for</span>
				  <span className="card-line">affordable homeownership.</span>
				</span>
			  </LandingCard>

			  <LandingCard
				backgroundImages={cardBackgroundImages[2]}
				linkUrl="/style"
				headerText="Style"
				animationColor={colors.secondaryKiddiePool}
        onClick={() => {send('HIM2018', 'Button', 'Main LP - Style');}}>
				<span className="view-mobile view-tablet">Get the style you want at a price you'll love.</span>
				<span className="view-desktop">
				  <span className="card-line">Get the style you want at a price</span>
				  <span className="card-line">you'll love.</span>
				</span>
			  </LandingCard>

			</div>
			<LandingFooter />
			<ScriptTags />
      <Helmet 
              meta={[
                  { 'name': 'viewport', 'content': 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no' },
                  { 'name': 'referrer', 'content': 'always'},
                  { 'charset': 'UTF-8' },
                  { 'http-equiv': 'X-UA-Compatible', 'content': 'IE=edge' }
              ]}
              onChangeClientState={onHelmetChangeClientState}
              script={[
                {
                type: 'text/javascript',
                innerHTML: `
                    if (typeof fbq !== 'undefined'){
                        fbq('track', 'PageView');
                    } else {
                      console.error('fbq not loaded');
                    }
                    if (typeof gtag !== 'undefined'){
                        gtag('event', 'page_view', {'send_to': 'AW-1040796449','dynx_itemid': 'HIM2018','dynx_pagetype': 'landing-page'});
                        gtag('event', 'conversion', {
                          'allow_custom_scripts': true,
                          'send_to': 'DC-6346097/fall1003/fall10+standard'
                      });
                    } else {
                      console.error('gtag not loaded');
                    }
                `
              }
            ]}
        >
        <title>Have It Made | Clayton Homes</title> 
      </Helmet>

      {/* Adobe Pixel Code */}
      <img src="http://conv-tm.everesttech.net/stats/1/conv?cpk=OQmjPowBJ13hBw5Q5ygg&cak=TU1toTr1MuUd0sWsxs4Z" />
      <img src="https://rtd-tm.everesttech.net/upi/?sid=AUjRvIoCguSZPQwST3fX&cs=1"/>
      {/* End Adobe Pixel Code */}

		  </LandingPageContainer>
		);
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js